
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class PaytableFeatures extends Vue {
    get lang (): string {
        return window.lang;
    }
}
